import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const NextEpisodeButtonContainer = styled.div<Props>`
  background: ${(props) => (props.focused ? Colors['light'] : 'none')};
  border: ${(props) =>
    !props.focused
      ? `${Colors['light']} ${2 * Screen.widthRatio}px solid`
      : 'none'};
  border-radius: ${10 * Screen.widthRatio}px;
  color: ${(props) =>
    props.focused ? `${Colors['button']['text']}` : `${Colors['light']}`};
  cursor: pointer;
  font-family: ${Fonts['regular']};
  font-size: ${32 * Screen.widthRatio}px;
  height: ${(props) => (props.focused ? 60 : 56) * Screen.widthRatio}px;
  margin-left: ${16 * Screen.widthRatio}px;
  overflow: hidden;
  width: fit-content;
  z-index: 1;

  &:hover {
    background: ${Colors['light']};
    border: none;
    color: ${Colors['button']['text']};
    height: ${60 * Screen.widthRatio}px;
  }

  &:hover > :nth-child(2) {
    background: ${Colors['progress']['fillNextEpisode']};
  }
`;

export default withAnimation(NextEpisodeButtonContainer);
